/* ============================================================
   LAO Care : formulaire de recrutement multi-étapes inline.
   Navigation entre écrans + validation + upload Cloudinary + soumission Klaviyo onsite.
   Cle publique Klaviyo (company_id) = RkCp6D (identique au diagnostic / testeurs).
   ============================================================ */
(function () {
  class RecrutementForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-rf-form]');
      this.screens = Array.from(this.querySelectorAll('.rf__screen'));
      this.nav = this.querySelector('[data-rf-nav]');
      this.prevBtn = this.querySelector('[data-rf-prev]');
      this.nextBtn = this.querySelector('[data-rf-next]');
      this.bar = this.querySelector('[data-rf-bar]');
      this.stepEl = this.querySelector('[data-rf-step]');
      this.totalEl = this.querySelector('[data-rf-total]');
      this.progress = this.querySelector('[data-rf-progress]');
      this.noteEl = this.querySelector('[data-rf-note]');
      this.listId = (this.dataset.listId || '').trim();
      this.cloudName = (this.dataset.cloudName || '').trim();
      this.uploadPreset = (this.dataset.uploadPreset || '').trim();
      this.sheetWebhookUrl = (this.dataset.sheetWebhookUrl || '').trim();
      // Écran de détail de l'offre (rempli dynamiquement)
      this.detailTitleEl = this.querySelector('[data-rf-detail-title]');
      this.detailMetaEl = this.querySelector('[data-rf-detail-meta]');
      this.detailFullEl = this.querySelector('[data-rf-detail-full]');
      // Détails de l'offre sélectionnée
      this.offreContrat = '';
      this.offreLieu = '';
      this.selectedIndex = '';
      // Étapes navigables (hors écran de confirmation)
      this.steps = this.screens.filter(function (s) { return s.dataset.screen !== 'done'; });
      this.pos = 0;
      this.offre = '';
      this.bind();
      if (this.totalEl) this.totalEl.textContent = this.steps.length;
      this.show(0);
    }

    bind() {
      var self = this;
      // Sélecteur d'offre : on écoute le 'change' du radio (clavier, etc.)
      this.querySelectorAll('[data-rf-offer-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) self.selectOffer(input);
        });
      });
      // Fiabilisation : un clic sur la carte/label coche explicitement le radio
      // puis exécute la logique de sélection. Ne dépend pas que de 'change'.
      this.querySelectorAll('[data-rf-offer]').forEach(function (label) {
        label.addEventListener('click', function (e) {
          // On laisse passer le lien « Voir le détail » sans changer d'offre
          if (e.target && e.target.closest && e.target.closest('[data-rf-offer-link]')) return;
          var input = label.querySelector('[data-rf-offer-input]');
          if (!input) return;
          input.checked = true;
          self.selectOffer(input);
        });
      });
      // Bouton « Postuler à cette offre » (écran de détail) -> avance vers les coordonnées
      var applyBtn = this.querySelector('[data-rf-apply]');
      if (applyBtn) applyBtn.addEventListener('click', function () { self.next(); });
      // Ne pas changer d'offre quand on clique le lien « Voir le détail »
      this.querySelectorAll('[data-rf-offer-link]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.stopPropagation(); });
      });
      // Affiche le nom du fichier choisi
      this.querySelectorAll('input[type="file"][data-rf]').forEach(function (input) {
        var key = input.getAttribute('data-rf');
        var nameEl = self.querySelector('[data-rf-filename="' + key + '"]');
        input.addEventListener('change', function () {
          input.classList.remove('is-error');
          var box = input.closest('.rf__upload');
          if (box) box.classList.remove('is-error');
          if (nameEl) nameEl.textContent = (input.files && input.files[0]) ? input.files[0].name : 'Aucun fichier sélectionné';
        });
      });
      // Nettoie l'erreur quand on tape
      this.querySelectorAll('[data-rf]:not([type="file"])').forEach(function (el) {
        el.addEventListener('input', function () { el.classList.remove('is-error'); });
      });
      this.nextBtn.addEventListener('click', function () { self.next(); });
      this.prevBtn.addEventListener('click', function () { self.prev(); });
    }

    // Logique centrale de sélection d'une offre (appelée par 'click' et par 'change').
    selectOffer(input) {
      this.offre = input.value;
      this.offreContrat = input.getAttribute('data-offre-contrat') || '';
      this.offreLieu = input.getAttribute('data-offre-lieu') || '';
      this.selectedIndex = input.getAttribute('data-offre-index') || '';
      this.fillDetail();
      this.clearError();
    }

    show(pos) {
      if (pos < 0) pos = 0;
      if (pos > this.steps.length - 1) pos = this.steps.length - 1;
      this.pos = pos;
      var active = this.steps[pos];
      this.screens.forEach(function (s) { s.classList.toggle('is-active', s === active); });
      this.prevBtn.style.visibility = pos === 0 ? 'hidden' : 'visible';
      // Sur l'écran « Détail de l'offre », le seul bouton d'avancée est « Postuler à cette offre ».
      // On masque alors la navigation « Continuer » pour ne pas afficher deux boutons en même temps.
      var isDetail = active.dataset.screen === 'detail';
      this.nextBtn.style.display = isDetail ? 'none' : '';
      this.nextBtn.textContent = (pos === this.steps.length - 1) ? 'Envoyer ma candidature' : 'Continuer →';
      this.nextBtn.classList.toggle('rf__btn--final', pos === this.steps.length - 1);
      this.updateGauge();
      this.clearError();
      this.scrollTop();
    }

    updateGauge() {
      var total = this.steps.length;
      var done = this.pos + 1;
      var pct = total ? Math.round(done / total * 100) : 0;
      if (this.bar) this.bar.style.width = pct + '%';
      if (this.stepEl) this.stepEl.textContent = done;
    }

    // Remplit l'écran « Détail de l'offre » avec l'offre sélectionnée
    fillDetail() {
      var sel = this.selectedIndex;
      this.querySelectorAll('[data-rf-detail-for]').forEach(function (d) {
        d.hidden = d.getAttribute('data-rf-detail-for') !== sel;
      });
    }

    val(key) { var el = this.querySelector('[data-rf="' + key + '"]'); return el ? (el.value || '').trim() : ''; }
    file(key) { var el = this.querySelector('input[type="file"][data-rf="' + key + '"]'); return (el && el.files && el.files[0]) ? el.files[0] : null; }
    errEl() { return this.querySelector('[data-rf-error="' + this.steps[this.pos].dataset.screen + '"]'); }
    clearError() {
      this.querySelectorAll('.rf__error').forEach(function (e) { e.classList.remove('is-shown'); e.textContent = ''; });
    }
    showError(msg, fieldKey) {
      var e = this.errEl();
      if (e) { e.textContent = msg; e.classList.add('is-shown'); }
      if (fieldKey) {
        var f = this.querySelector('[data-rf="' + fieldKey + '"]');
        if (f) {
          f.classList.add('is-error');
          var box = f.closest('.rf__upload');
          if (box) box.classList.add('is-error');
          if (typeof f.focus === 'function') { try { f.focus(); } catch (err) {} }
        }
      }
    }
    showNote(msg) { if (this.noteEl) { this.noteEl.textContent = msg; this.noteEl.classList.add('is-shown'); } }

    validateStep() {
      var step = this.steps[this.pos].dataset.screen;
      if (step === '1') {
        if (!this.offre) { this.showError('Merci de sélectionner une offre.'); return false; }
        return true;
      }
      if (step === 'detail') {
        // L'offre reste obligatoire pour avancer
        if (!this.offre) { this.showError('Merci de sélectionner une offre.'); return false; }
        return true;
      }
      if (step === '2') {
        if (!this.val('firstname')) { this.showError('Merci d’indiquer votre prénom.', 'firstname'); return false; }
        if (!this.val('lastname')) { this.showError('Merci d’indiquer votre nom.', 'lastname'); return false; }
        var email = this.val('email');
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { this.showError('Merci d’indiquer un e-mail valide.', 'email'); return false; }
        if (!this.val('phone')) { this.showError('Merci d’indiquer votre numéro de téléphone.', 'phone'); return false; }
        return true;
      }
      if (step === '3') {
        if (!this.file('cv')) { this.showError('Merci d’ajouter votre CV (PDF).', 'cv'); return false; }
        var consent = this.querySelector('[data-rf="consent"]');
        if (consent && !consent.checked) { this.showError('Merci d’accepter le traitement de vos données.'); return false; }
        return true;
      }
      return true;
    }

    next() {
      if (!this.validateStep()) return;
      if (this.pos < this.steps.length - 1) { this.show(this.pos + 1); return; }
      // Dernière étape -> soumission
      this.submit();
    }
    prev() { if (this.pos > 0) this.show(this.pos - 1); }

    collect() {
      var indic = this.val('indicatif');
      var phoneNum = this.val('phone');
      var phoneDigits = phoneNum.replace(/\D/g, '').replace(/^0+/, '');
      var phoneE164 = (phoneNum && indic) ? (indic + phoneDigits) : '';
      return {
        offre: this.offre,
        firstname: this.val('firstname'),
        lastname: this.val('lastname'),
        email: this.val('email'),
        phone: phoneE164 || ((indic ? indic + ' ' : '') + phoneNum),
        phoneE164: phoneE164,
        linkedin: this.val('linkedin'),
        portfolioLink: this.val('portfolio_link'),
        message: this.val('message'),
        cvUrl: '',
        portfolioUrl: ''
      };
    }

    // Upload Cloudinary unsigned. Résout toujours (jamais de rejet) pour ne pas bloquer la soumission.
    uploadFile(fileObj) {
      var self = this;
      return new Promise(function (resolve) {
        if (!fileObj || !self.cloudName || !self.uploadPreset) { resolve(''); return; }
        var fd = new FormData();
        fd.append('file', fileObj);
        fd.append('upload_preset', self.uploadPreset);
        fetch('https://api.cloudinary.com/v1_1/' + self.cloudName + '/auto/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (json) { resolve(json && json.secure_url ? json.secure_url : ''); })
          .catch(function () { resolve(''); });
      });
    }

    submit() {
      var self = this;
      this.nextBtn.disabled = true;
      this.nextBtn.textContent = 'Envoi en cours…';
      var p = this.collect();

      if (!this.cloudName || !this.uploadPreset) {
        this.showNote('Note : l’hébergement des fichiers n’est pas encore configuré, votre candidature nous est tout de même transmise.');
      }

      var cvFile = this.file('cv');
      var pfFile = this.file('portfolio');

      Promise.all([this.uploadFile(cvFile), this.uploadFile(pfFile)])
        .then(function (urls) {
          p.cvUrl = urls[0] || '';
          p.portfolioUrl = urls[1] || '';
        })
        .catch(function () {})
        .then(function () {
          self.pushKlaviyo(p);
          self.subscribeToList(p);
          self.pushSheet(p);
          self.goDone();
        });
    }

    // Identification + event via l'objet onsite Klaviyo (klaviyo.identify / klaviyo.track).
    pushKlaviyo(p) {
      try {
        var k = window.klaviyo || window._learnq;
        if (!k || !p.email) return;
        var idAttrs = {
          '$email': p.email,
          '$first_name': p.firstname,
          '$last_name': p.lastname,
          'Offre': p.offre,
          'LinkedIn': p.linkedin,
          'CV_URL': p.cvUrl,
          'Portfolio_URL': p.portfolioUrl,
          'PortfolioLien': p.portfolioLink,
          'Message': p.message
        };
        if (p.phoneE164) idAttrs['$phone_number'] = p.phoneE164;
        // Compat des deux API : klaviyo.identify(...) sinon klaviyo.push(['identify', ...])
        if (typeof k.identify === 'function') { k.identify(idAttrs); }
        else { k.push(['identify', idAttrs]); }

        var eventProps = {
          Prenom: p.firstname,
          Nom: p.lastname,
          Email: p.email,
          Telephone: p.phone,
          Offre: p.offre,
          LinkedIn: p.linkedin,
          CV_URL: p.cvUrl,
          Portfolio_URL: p.portfolioUrl,
          PortfolioLien: p.portfolioLink,
          Message: p.message,
          Source: 'Page Recrutements'
        };
        if (typeof k.track === 'function') { k.track('Candidature Recrutement', eventProps); }
        else { k.push(['track', 'Candidature Recrutement', eventProps]); }
      } catch (e) {}
    }

    // Abonnement direct à la liste « Candidats recrutement ».
    // Ne s'exécute QUE si l'ID de liste est renseigné (réglage data-list-id de la section).
    // Tant qu'il est vide, on s'appuie sur l'event « Candidature Recrutement » (segment possible).
    subscribeToList(p) {
      var LISTE_ID_KLAVIYO = this.listId;
      if (!LISTE_ID_KLAVIYO) return;
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RkCp6D', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Candidature Recrutement',
                profile: { data: { type: 'profile', attributes: {
                  email: p.email,
                  first_name: p.firstname,
                  last_name: p.lastname,
                  phone_number: p.phoneE164 || undefined,
                  properties: { Offre: p.offre, LinkedIn: p.linkedin, CV_URL: p.cvUrl, Portfolio_URL: p.portfolioUrl }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: LISTE_ID_KLAVIYO } } }
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    // Remontée vers un Google Sheet via webhook (Apps Script Web App).
    // POST text/plain pour éviter le preflight CORS. Ne s'exécute que si l'URL est renseignée.
    pushSheet(p) {
      var url = this.sheetWebhookUrl;
      if (!url) return;
      try {
        fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            date: new Date().toISOString(),
            offre: p.offre,
            prenom: p.firstname,
            nom: p.lastname,
            email: p.email,
            telephone: p.phone,
            linkedin: p.linkedin,
            cv_url: p.cvUrl,
            portfolio_url: p.portfolioUrl,
            portfolio_lien: p.portfolioLink,
            message: p.message
          })
        }).catch(function () {});
      } catch (e) {}
    }

    goDone() {
      var done = this.screens.filter(function (s) { return s.dataset.screen === 'done'; })[0];
      this.screens.forEach(function (s) { s.classList.toggle('is-active', s === done); });
      if (this.nav) this.nav.style.display = 'none';
      if (this.progress) this.progress.style.display = 'none';
      if (this.noteEl) this.noteEl.classList.remove('is-shown');
      this.scrollTop();
    }

    scrollTop() {
      try {
        var wrap = this.querySelector('.rf__wrap') || this;
        var off = (window.innerWidth <= 749 ? 56 : 70);
        var y = wrap.getBoundingClientRect().top + window.pageYOffset - off;
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo({ top: y, behavior: 'auto' });
      } catch (e) {}
    }
  }

  if (!customElements.get('recrutement-form')) customElements.define('recrutement-form', RecrutementForm);
})();
